import { render, staticRenderFns } from "./MultiselectOptionV2.vue?vue&type=template&id=2cc4717d&"
import script from "./MultiselectOptionV2.vue?vue&type=script&lang=js&"
export * from "./MultiselectOptionV2.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MultiselectOptionV2.vue?vue&type=style&index=1&id=2cc4717d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports